import styled from 'styled-components';
import { HashLink as RouterLink } from 'react-router-hash-link';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const ItemExternal = styled.a`
  display: inline-block;
  margin: 0 auto;
`;

export const Item = styled(RouterLink)`
  display: inline-block;
  margin: 0 auto;
  cursor: pointer;
`;

export const Imagebox = styled.picture`
  display: block;
  max-width: 100%;
  height: auto;
`;

export const Image = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
  object-fit: cover;
  user-select: none;
  pointer-events: none;
`;

export const Source = styled.source``;
